import { alaskaToday } from "./dates.js";

// The office's cargo and yacht paper blanks under "Prefer to fill one by
// hand?" on the trip page. Each year listed has its own files in
// public/templates (made by scripts/build-paper-blanks-year.mjs); the link
// switches on 1 January Alaska time (Jill 2026-10-12).
export const PAPER_BLANK_YEARS = [2026, 2027];

export function paperBlankYear(now = new Date()) {
  const thisYear = Number(alaskaToday(now).slice(0, 4));
  return PAPER_BLANK_YEARS.filter((y) => y <= thisYear).pop() ?? PAPER_BLANK_YEARS[0];
}

export function paperBlanks(now = new Date()) {
  const year = paperBlankYear(now);
  return [
    { href: `/templates/cargo-pilotage-sheet-${year}.pdf`, label: `${year} Cargo Pilotage Sheet` },
    { href: `/templates/yacht-pilotage-sheet-${year}.pdf`, label: `${year} Yacht Pilotage Sheet` },
  ];
}

// How long a page should wait before checking the links again: until 1
// January 00:00 Alaska (09:00 UTC in winter), capped at the longest browser
// timer (about 24.8 days) so a page opened weeks earlier wakes, rechecks and
// waits again. null when no newer year is listed. Lets a page left open
// across New Year's Eve switch without a reload (Codex on #586).
const MAX_TIMER_MS = 2 ** 31 - 1;
export function msUntilNextPaperBlankYear(now = new Date()) {
  const thisYear = Number(alaskaToday(now).slice(0, 4));
  if (!PAPER_BLANK_YEARS.some((y) => y > thisYear)) return null;
  const ms = Date.UTC(thisYear + 1, 0, 1, 9) - now.getTime();
  return Math.min(Math.max(ms, 0), MAX_TIMER_MS);
}
